module.exports = __webpack_public_path__ + "static/img/83.b4c7a22.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/83.png
// module id = XMoD
// module chunks = 1